import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { TEAM, EXHIBITION_IMAGES } from "@/data/content";
import { useT } from "@/i18n";

export default function OurTeam() {
  const t = useT();
  return (
    <div data-testid="team-page" className="bg-white">
      <PageHero
        eyebrow={t.pages.team.eyebrow}
        title={t.pages.team.title}
        subtitle={t.pages.team.subtitle}
        image={EXHIBITION_IMAGES[1]}
      />

      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
            {TEAM.map((m, i) => (
              <Reveal key={m.name} delay={i * 80}>
                <article data-testid={`team-card-${i}`} className="group">
                  <div className="relative aspect-[3/4] overflow-hidden bg-black/5">
                    <img
                      src={m.image}
                      alt={m.name}
                      className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-[1200ms] ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-x-0 bottom-0 h-1 bg-[#C20E1A] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700" />
                  </div>
                  <div className="pt-5">
                    <h3 className="text-lg sm:text-xl font-bold uppercase tracking-tight text-black">
                      {m.name}
                    </h3>
                    <p className="mt-1 text-xs uppercase tracking-[0.25em] text-[#C20E1A] font-bold">
                      {m.role}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
